import { useState } from 'react'

import type { Budget } from '../../demo/types'
import { Button, Icon, Input } from '../../ui'
import styles from './CreatePage.module.css'

interface BudgetFieldProps {
  value: Budget
  onChange: (value: Budget) => void
}

export function BudgetField({ value, onChange }: BudgetFieldProps) {
  const [editing, setEditing] = useState(false)
  const valid = value.dailyMin >= 0 && value.dailyMin < value.dailyMax
  const update = (key: 'dailyMin' | 'dailyMax', raw: string) => {
    onChange({ ...value, [key]: Number(raw) })
  }

  return (
    <section className={`${styles.field} ${styles.lastField}`} data-scope="create-budget-field">
      <div className={styles.labelRow}><span className={styles.label}>预算</span></div>
      {editing ? (
        <div className={styles.budgetEdit}>
          <label><span>下限 $ / 天</span><Input type="number" min="0" value={value.dailyMin} onChange={(event) => update('dailyMin', event.target.value)} /></label>
          <span className={styles.budgetDash}>–</span>
          <label><span>上限 $ / 天</span><Input type="number" min="0" value={value.dailyMax} error={!valid} onChange={(event) => update('dailyMax', event.target.value)} /></label>
          <Button variant="secondary" disabled={!valid} onClick={() => setEditing(false)}>完成</Button>
        </div>
      ) : (
        <button type="button" className={styles.readonlyInput} onClick={() => setEditing(true)}>
          <span>{`$${value.dailyMin} – $${value.dailyMax} / 天`}</span><Icon name="pencil" size={18} />
        </button>
      )}
    </section>
  )
}
